import { configureStore, combineReducers } from "@reduxjs/toolkit";
import userSlice from "./slices/user-slice";
import globalSlice from "./slices/global.store";

// Tạo rootReducer bằng cách kết hợp các reducer của ứng dụng
const rootReducer = combineReducers({
  user: userSlice.reducer,
  global: globalSlice,
});

// Định nghĩa các hàm action có thể trả về một hàm bất đồng bộ

// Định nghĩa RootState là kiểu dữ liệu tổng hợp của tất cả các reducer trong rootReducer

const store = configureStore({
  reducer: rootReducer,
});

export default store;
